import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'peso'
})
export class PesoPipe implements PipeTransform {
  private currencyPipe = new CurrencyPipe('en');

  transform(value: number | string | null | undefined, digitsInfo: string = '1.2-2'): string | null {
    if (value === null || value === undefined) return null;
    return this.currencyPipe.transform(value, '₱', 'symbol', digitsInfo);
  }
}
